<label [ngClass]="{ required: required }" class="pt-2">{{ labelText }}</label>
<div class="list cursor-pointer" [ngClass]="theme">
  <div class="list-item-box cursor-pointer" *ngFor="let item of options">
    <app-checkbox class="col-12 cursor-pointer" [checked]="item.checked" [text]="item.displayName" (onChecked)="onItemChecked(item, $event)"></app-checkbox>
  </div>
</div>
<app-input-error-message *ngIf="errorMessage.length > 0" [errorMessage]="errorMessage">
</app-input-error-message>
<mat-hint class="pb-2" *ngIf="hint.length > 0">{{ hint }}</mat-hint>
